module.exports = __webpack_public_path__ + "static/img/list1.2cd88d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/longda/list1.png
// module id = dJBz
// module chunks = 39